import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import '@src/pages/common/button/CommonButton.scss';
const CommonButton = ({
  label = '',
  onClick = () => {},
  size = 'small',
  startIconProp = '',
  iconOrintation = 'start',
  showIcon = false,
  btnType = 'primary',
  className = '',
  ...props
}) => {
  const getVariantClass = () => {
    switch (btnType) {
      case 'primary':
        return 'rs_primary_btn';
      case 'secondary':
        return 'rs_secondary_btn';
      case 'destructive':
        return 'rs_destructive_btn';
      case 'success':
        return 'rs_success_btn';
      case 'whitelist':
        return 'rs_whitelist_btn';
      case 'disable':
        return 'rs_disable_btn';
      default:
        return 'rs_primary_btn';
    }
  };
  return (
    <div className={`${getVariantClass()} ${className}`}>
      <Button onClick={onClick} startIcon={showIcon && iconOrintation === 'start' && startIconProp} {...props}>
        {label}
      </Button>
    </div>
  );
};
CommonButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  iconOrintation: PropTypes.string,
  startIconProp: PropTypes.string,
  btnType: PropTypes.string,
  showIcon: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'large', 'medium']),
};
export default CommonButton;
